const CurrencySwitcher = ({ handleCurrencyChange }) => {
  return (
    <div className='currency-switcher'>
      <div className='currency euro'>{I18n.locale == 'cs' ? 'Kč' : '€'}</div>
      <div className='onoffswitch'>
        <input
          type='checkbox'
          name='dollars'
          id='dollars'
          className='onoffswitch-checkbox'
          onChange={handleCurrencyChange}
        />
        <label className='onoffswitch-label' htmlFor='dollars'>
          &nbsp;
        </label>
      </div>
      <div className='currency dollar'>{I18n.locale == 'cs' ? '€' : '$'} </div>
    </div>
  );
};

export default CurrencySwitcher;
